const languageData = [
  {
    languageId: "italian",
    locale: "it",
    name: "Uzbek",
    icon: "uz",
  },
  {
    languageId: "french",
    locale: "fr",
    name: "Russian",
    icon: "ru",
  },
  {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us",
  },
];
export default languageData;
